// Horizontal Linear Stapper
import React, { Fragment } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';


import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

// import TextField from '@mui/material/TextField';

import moment from 'moment';
// import DateFnsUtils from '@date-io/date-fns';
// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // Or AdapterMoment, AdapterDayjs, etc.
import TextField from '@mui/material/TextField';



// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    allStudents,
    allProgramInclusion,
    addAcademyAdmin,
    assignProgramInclusion
} from 'Actions';

function getSteps() {
   return ['Create Visiting Student'];
}


class StudentWorkflow extends React.Component {
   static propTypes = {
      classes: PropTypes.object,
   };

   UNSAFE_componentWillMount() {
        this.props.allStudents();   
        this.props.allProgramInclusion();   
	}

   state = {
      activeStep: 0,
      skipped: new Set(),
      academy:"",
      selstudent:"",
      selectedDate: moment(),
      lstaction:0,
      selprogram:[],
   };
   isStepOptional = step => {
      return step === 1;
   };
   isStepSkipped(step) {
      return this.state.skipped.has(step);
   }
   handleNext = () => {
      const { activeStep } = this.state;
      let { skipped } = this.state;
      let { lstaction } = this.state;
      let { selstudent } = this.state;
      let { selprogram } = this.state;
      if(activeStep==0){
          if(lstaction==0 && selstudent==""){
            alert('Please select the student or create student');   
          }else{            
            this.setState({
                activeStep: 1,
            });
          }   
      }else if(activeStep==1){ 
            if(selprogram.length==0){
                this.setState({
                    activeStep: 2,
                 });
            }else{
                const commaSep = selprogram.join(',');                
                this.props.assignProgramInclusion(selstudent,commaSep).then((data) => {         
                    if(data.status==1){
                    this.setState({
                        activeStep: 2,
                    });
                    
                    }
                });
            }        
      }else{
        
         if(this.isStepSkipped(activeStep)) {
            skipped = new Set(skipped.values());
            skipped.delete(activeStep);
         }
         this.setState({
            activeStep: activeStep + 1,
            skipped,
         });
      }
   };

    multiSelectChange = (e) => {
        this.setState({selstudent: e.value});
    }

    handleChange = (e) => {
        let tstchk=e.target.checked;
        let optval=e.target.value;
        
        if(tstchk==true){
            this.setState({
                selprogram:[...this.state.selprogram, optval]
              });
        }else{
            let filteredArray = this.state.selprogram.filter(item => item !== optval)
            this.setState({selprogram: filteredArray});
        }        
    }

   handleBack = () => {
      const { activeStep } = this.state;
      this.setState({
         activeStep: activeStep - 1,
      });
   };

   handleDateChange = (e) => {
       
       let seldate=e;
       this.setState({selectedDate: e});
   }
  
   addHandleSubmit(event){
      event.preventDefault();
      
      this.props.addAcademyAdmin(event,0,this.state.selectedDate,39).then((data) => {         
         if(data.status==1){
            const adstud=data.data;
            this.setState({
               selstudent: adstud, 
               lstaction:1,
               activeStep:1,
            });
            document.getElementById("membersform").reset(); 
         }
      });
      
   }

   render() {
      const steps = getSteps();
      const { activeStep } = this.state;
      const { studentlists, programinclusionlists, loading } = this.props;
      
      const allstudent=studentlists.map((stdval) => {  
        return {
        label: stdval.student,  
        value: stdval.uudID
        }
      });
      return (
         <div className="hoz-linear-stepper">
            <Stepper alternativeLabel nonLinear activeStep={activeStep}>
               {steps.map((label, index) => {
                  const props = {};
                  const labelProps = {};
                  if (this.isStepOptional(index)) {
                     labelProps.optional = '';
                  }
                  if (this.isStepSkipped(index)) {
                     props.completed = false;
                  }
                  return (
                     <Step key={label} {...props}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                     </Step>
                  );
               })}
            </Stepper>
            <div className="pl-40">
                 
                  {(function(){
                  if (activeStep === 0) {

                  //{activeStep === 0 ? (
                     return <div>

                         <div className="row">
                           <div className="col-md-12">
                                <div className="col-md-8">                                    
                                    
                                    <div className="col-md-12">
                                        <RctCollapsibleCard>
                                        <form autoComplete="off"  id="membersform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                            <h4>Add Student</h4>
                                            <div className="form-group">
                                            <TextField  required id="fname" name="fname" fullWidth label="First Name" />
                                            </div>
                                            <div className="form-group">
                                            <TextField required id="lname" name="lname" fullWidth label="Last Name" />
                                            </div>
                                            <div className="form-group">
                                            <TextField  type="email" required id="email" name="email" fullWidth label="Email" />
                                            </div>
                                            <div className="form-group">
                                            <TextField  type="phone" required id="mobile" name="mobile" fullWidth label="Mobile" />
                                            </div>
                                            <div className="form-group">
                                            
                                            <Fragment>
                                               <div className="rct-picker">
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Date of Birth"
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            inputFormat="yyyy-MM-dd"
            components={{
              LeftArrowIcon: () => <i className="zmdi zmdi-arrow-back" />,
              RightArrowIcon: () => <i className="zmdi zmdi-arrow-forward" />,
            }}
            renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
          />
        </LocalizationProvider>
      </div>
                                            </Fragment>
                                        
                                            </div>
                                             <FormControl fullWidth>
                                                <InputLabel htmlFor="age-simple">Gender</InputLabel>
                                                <Select inputProps={{ name: 'gender', id: 'gender', }} required >
                                                   <MenuItem value=""><em>None</em></MenuItem>
                                                   <MenuItem value="1"><em>Male</em></MenuItem>
                                                   <MenuItem value="2"><em>Female</em></MenuItem>                                   
                                                </Select>
                                             </FormControl> 
                                            {/* <div className="form-group">
                                            <TextField type="password" required id="password" name="password" fullWidth label="Password" />
                                            </div> */}
                                            <div className="form-group"></div>
                                            <div className="form-group">
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                            </div>
                                        </form>  
                                        </RctCollapsibleCard> 
                                    </div>
                                </div>
                            </div>
                           
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back
                              </Button>
                              {/* <Button variant="contained" onClick={this.handleNext} color="primary" className="text-white mr-3 mb-3">
                                 {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                              </Button> */}
                           
                        </div>   
                     </div>  
                   

                   }else{
                     return <div>
                           <div className="row">
                              <div className="col-md-12">
                                 <div className="alert bg-success text-white col-sm-12 col-md-6 col-lg-6" role="alert">
                                    <strong>Well done!</strong> You successfully added visting student.
                                 </div>
                              </div>
                              <Button onClick={this.props.onClick} className="btn-danger text-white mr-3 mb-3" >
                                 Back to Home
                              </Button>
                           </div>
                     </div>
                   }  
                  }).call(this)} 
                  
            </div>
         </div>
      );
   }
}

const mapStateToProps = ({mostlyused, programinclusion }) => {
   const { studentlists, loading } = mostlyused;
   const { programinclusionlists } = programinclusion;
	return { studentlists, programinclusionlists, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    allProgramInclusion,
    addAcademyAdmin,
    assignProgramInclusion
})(StudentWorkflow); 
